export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REDUCE_QTY = "REDUCE_QTY";
export const SET_PRODUCT = "SET_PRODUCT";
export const SET_BRAND = "SET_BRAND";
export const SET_ALL_SHOES = "SET_ALL_SHOES";
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const EMPTY_CART = "EMPTY_CART";
export const TOGGLE_IMG = "TOGGLE_IMG";
